import { z } from "zod";

import { createGenericStringSchema } from "~/common/utils/createGenericStringSchema";
import { zoomMeetingIdSchema } from "~/providers/utils/consultationRequests/schemas";

const createReimbursementReportDataSchema = (requiredFields: boolean) =>
  z.object({
    final_note: createGenericStringSchema({
      inputName: "progress note",
      required: requiredFields,
    }),
  });

export const reimbursementReportSchema = z.discriminatedUnion("saveData", [
  z.object({
    saveData: z.literal(false),
    data: createReimbursementReportDataSchema(true),
  }),
  z.object({
    saveData: z.literal(true),
    data: createReimbursementReportDataSchema(false),
  }),
]);

export type ReimbursementReportSchemaType = z.infer<
  typeof reimbursementReportSchema
>;

export const initiateReimbursementReportSchema = z.object({
  zoom_meeting_id: zoomMeetingIdSchema.refine((value) => value !== null, {
    message: "Please enter a valid Zoom meeting link or meeting ID.",
  }),
});

export type InitiateReimbursementReportSchemaType = z.infer<
  typeof initiateReimbursementReportSchema
>;
